import { h } from 'preact'
import Icon from '../assets'
import Switcher from '../control/Switcher'
import Textarea from '../ui-components/Textarea'
import { ActionButtons, HowToTextWithOpenInNewTabIcon, InformationCallout, PanelHeaderWithIcon } from './PanelItems'
import Tooltip from '../ui-components/Tooltip'

interface BodyProps {
    isRestrictPhoneNumberAsUsernameEnabled: boolean,
    isRestrictWordsInUsernameEnabled: boolean,
    showUsernameRestrictionsActionButtons: boolean,
    showValidationError: boolean,
    restrictedWords?: Array<string>,
    onSave: () => void,
    onCancel: () => void,
    onTextareaFocus: () => void,
    onRestrictPhoneNumberAsUsernameSettingChanged: (value: boolean) => void,
    onRestrictWordsInUsernameSettingChanged: (value: boolean) => void,
    onRestrictedWordsChanged: (value: string) => void
}

export const UsernameRestrictionsPanelBody = ({ isRestrictPhoneNumberAsUsernameEnabled, isRestrictWordsInUsernameEnabled, restrictedWords, showUsernameRestrictionsActionButtons, showValidationError, onSave, onCancel, onTextareaFocus, onRestrictPhoneNumberAsUsernameSettingChanged, onRestrictWordsInUsernameSettingChanged, onRestrictedWordsChanged } : BodyProps) => (
  <div className='panel-body-container'>
    <InformationCallout
      text={`Moderators can always change a username in Control (e.g. if you want to add your company name to an employee's username).`} />
    <Switcher
      on={isRestrictPhoneNumberAsUsernameEnabled}
      customClass='panel-switch'
      label='Block registrations with phone numbers as usernames.'
      onChange={() => onRestrictPhoneNumberAsUsernameSettingChanged(!isRestrictPhoneNumberAsUsernameEnabled)} />
    <HowToTextWithOpenInNewTabIcon
      label='How do we block phone numbers'
      url='https://community.insided.com/article/910?t=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcnRpY2xlX2lkIjo5MTB9.sjp-ncEssgsmL0IT3A6ygq0uIQpnocy-sSexwGLYcGo' />

    <div className='panel-switch-textarea-container'>
      <div className='switch-icon-container'>
        <Switcher
          on={isRestrictWordsInUsernameEnabled}
          customClass='panel-switch'
          label='Block registrations where username contains any of the following keywords (separated keywords by comma, e.g. moderator, staff).'
          onChange={() => onRestrictWordsInUsernameSettingChanged(!isRestrictWordsInUsernameEnabled)} />
        <Tooltip
          withArrow
          position='right'
          trigger={<Icon customClass='icon-help' icon='help' />}
          customClasses='panel-help-tooltip tooltip-message--right'
          tooltipMessage={`This filter matches based on a simple contains rule (e.g. all the following will match on the keyword 'inSided': 'INSIDED', 'inSided123','xinSidedx', 'inSided Fan'`}
        />
      </div>
      <div className='panel-textarea-container'>
        <Textarea
          value={restrictedWords?.join(', ')}
          disabled={!isRestrictWordsInUsernameEnabled}
          newStyle
          verticalResize
          placeholder='Add keywords...'
          onTextareaFocus={() => onTextareaFocus()}
          onContentChange={(value: string) => onRestrictedWordsChanged(value.trim())}
          class={`panel-text-area ${showValidationError ? 'panel-text-area-error' : ''} `}
        />
        {showValidationError &&
          <div className='error-message-container'>
            <div><Icon customClass='icon-warning' icon='warning' /></div>
            <div className='error-message'>Please fill in the required field</div>
          </div>
        }
      </div>
    </div>
    {showUsernameRestrictionsActionButtons &&
    <ActionButtons
      onSave={() => onSave()}
      onCancel={() => onCancel()} />
    }
  </div>
)

interface HeaderProps {
    statusText: string
}

export const UsernameRestrictionsPanelHeader = ({ statusText } : HeaderProps) => (
  <PanelHeaderWithIcon
    customClass='panel-header-container'
    iconCustomClass='icon-panel-header'
    icon='usernameRestrictions'
    title='Username restrictions'
    statusText={statusText} />
)
